import { objectfyArray } from "../helpers/objectfyArray";

const rewards = (state = {}, action) => {
  Object.freeze(state);
  let newState;
  switch (action.type) {
    case "SET_REWARDS":
      if (Array.isArray(action.rewards)) {
        return objectfyArray(action.rewards);
      } else {
        return action.rewards;
      }
    case "REMOVE_REWARDS":
      return {};
    case "SET_REWARD":
      return {
        ...state,
        [action.reward.id]: action.reward,
      };
    case "UPDATE_REWARD":
      newState = {
        ...state,
      };
      newState[action.reward.id] = action.reward;
      return newState;
    case "ADD_TEMP_REWARD":
      return {
        ...state,
        newReward: {
          id: "newReward",
          pointsForItem: "",
          finePrint: "",
          maxUses: null,
          item: "",
          requiresCode: 0,
          expiration: null,
        },
      };
    case "UPDATE_TEMP_REWARD":
      newState = {
        ...state,
      };
      delete newState.newReward;
      return {
        ...newState,
        [action.reward.id]: action.reward,
      };
    case "REMOVE_REWARD":
      newState = {
        ...state,
      };
      delete newState[action.reward.id];
      return newState;
    case "REMOVE_TEMP_REWARD":
      newState = {
        ...state,
      };
      delete newState["newReward"];
      return newState;
    default:
      return state;
  }
};

export default rewards;
